import React from 'react';
import CalendarTimeslotTable from '../TimeslotTable/new';
import CalendarHeader from '../Header';

interface Props {
  tutor: any;
  slotStatuses: any[];
  duration: any;
  myBookings: any[];
  holidays: any[];
  loadingSlotStatuses?: boolean;
  timeZone: any;
}

const Calendar: React.FC<Props> = (props: Props) => {
  const now = new Date();
  const {
    tutor,
    slotStatuses,
    duration,
    myBookings,
    holidays,
    loadingSlotStatuses,
    timeZone,
  } = props;
  const headerProps = {
    now,
    timeZone,
  };
  const timeslotTableProps = {
    now,
    tutor,
    slotStatuses,
    duration,
    myBookings,
    holidays,
    loadingSlotStatuses,
    timeZone,
  };

  return (
    <div>
      <CalendarHeader {...headerProps} />
      <div className="cal-week-timed">
        <table className="day">
          <tbody>
            <tr className="day-row">
              <td className="side"></td>
              <td className="day-col"></td>
              <td className="day-col"></td>
              <td className="day-col"></td>
              <td className="day-col"></td>
            </tr>
          </tbody>
        </table>
        <CalendarTimeslotTable {...timeslotTableProps} />
      </div>
    </div>
  );
};

export default Calendar;
